
import { Options, Vue } from "vue-class-component";
import ProfilerService from "../../service/ProfilerService.js";
import Toaster from "../../helpers/Toaster";
import ProfilerDialog from "../../components/ProfilerDialog.vue";
import FileUploader from "../../components/FileUploader.vue";
import { useStore, ActionTypes } from "../../store";
import moment from "moment";
import router from "../../router";

@Options({
  title: 'Supplier Credits',
  components: {
    ProfilerDialog,
    FileUploader
  },
})
export default class Suppliers extends Vue {
  private store = useStore();
  private menuBar = false;
  private receipts = false;
  private supplierReceipts = <any>[];
  private item = {
      id: 0,
      supplier_id: 0,        
  };
  private lists = [];
  private keyword = "";
  private dialogTitle = "";
  private statusType = "New";
  private toast;
  private profilerID = 0;
  private currentUserID = 0;
  private goToFirstLink = 0;
  private goToSubFirstLink = 0;
  private profilerService;
  private checkPagination = true;
  private checkSubPagination = true;
  private profileStatus = false;
  private statusDialog = false;
  private totalRecords = 0;
  private totalSubRecords = 0;
  private limit = 0;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Initialization", to: "/store/initialization" },
    { label: "Supplier Credits", to: "suppliers" },
  ];

  private excelFileContent = [
    {
      'accountTitle' : '',
			'emailAddress' : '',
			'contactNo' : '',
			'nationalID'      : '',
      'address' : '',
			'accountType' : 'Customer',
      'company'          : '',
      'defaultExpiryAlertDuration':'',
			'description'      : '',
      'status'           : '',
    }
  ];
  private uploaderStatus = false;
  //CALLING WHEN PAGINATION BUTTON CLICKS
  onPage(event) {
    this.loadList(event.first);
  }

  onSubPage(event) {
    this.profilerService.getHistory(this.item.id, event.first).then((res) => {

      if (res.status_id == 1) {
          this.supplierReceipts = res.records;
          this.totalSubRecords = res.totalRecords;
          this.limit = res.limit;

          this.supplierReceipts.forEach((supplierItem) => {
            supplierItem.paid = 0;
            // item.supplier_settle_payments.forEach((subItem) => {
            //   item.paid += subItem.trans_amount;
            // });

            supplierItem.payable = supplierItem.total_bill - supplierItem.paid;
            
          });
        } else {
          this.supplierReceipts = [];
        }
      });
  }

  //DEFAULT METHOD OF TYPE SCRIPT
  created() {
    this.profilerService = new ProfilerService();
    this.toast = new Toaster();
  }

  //CALLNING AFTER CONSTRUCTOR GET CALLED
  mounted() {
    this.loadList(0);
  // Add event listener for keypress
  window.addEventListener('keypress', this.handleKeypress);
  }
  
  beforeUnmount() {
  // Remove event listener
  window.removeEventListener('keypress', this.handleKeypress);
  }

  handleKeypress(event) {
      // Check for "Enter" key to detect the end of scanning
      if (event.key === 'Enter') {
        this.loadList(this.goToFirstLink);
      } else {
      }
    } 

  cleanSearchData() {
    this.keyword = '';
    this.goToFirstLink = 0;
    this.loadList(0);
  }

  //FETCH THE DATA FROM SERVER
  loadList(page) {
    this.profilerService.getSupplierCreditList(this.keyword, page).then((data) => {
      this.lists = data.records;
      this.totalRecords = data.totalRecords;
      this.limit = data.limit;
      this.currentUserID = data.currentUserID;
    });
  }

  loadSearchData() {
    if (this.keyword) {
      this.goToFirstLink = 0;
      this.loadList(0);
    }
  }



  clearAll() {
    this.excelFileContent = [];
    this.toast.showSuccess("Cleared Successfully");
  }

  get currency() {
      return this.store.getters.getCurrency;
  }

  openMenu(data) {
      this.menuBar = true;
      this.item.id = data.id;
      this.receipts = false;
  }

  viewHistory(){
    this.profilerService.getHistory(this.item.id, this.goToSubFirstLink).then((res) => {
        this.receipts = true;
        this.menuBar = false;
        if (res.status_id == 1) {
          this.supplierReceipts = res.records;
          this.totalSubRecords = res.totalRecords;
          this.limit = res.limit;

          this.supplierReceipts.forEach((item) => {
            item.paid = 0;
            // item.supplier_settle_payments.forEach((subItem) => {
            //   item.paid += subItem.trans_amount;
            // });

            item.payable = item.total_bill - item.paid;
            
          });
        } else {
          this.supplierReceipts = [];
        }
      });
  }

  viewTransactions(){
    router.replace({ 
      path: "/process/transactions", 
      query: { 
        supplier_id: this.item.id, 
        type: 'PUR' 
      } 
    });
  }

  formatDateTime(date) {
    return moment(date).format("DD-MM-YYYY hh:mm A");
  }
}
